// extracted by mini-css-extract-plugin
export default {"table":"TicketReaderList_table__u5Bs-","badge":"TicketReaderList_badge__P6avY","btn":"TicketReaderList_btn__D2PSQ"};